import dayjs from 'dayjs';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { HORIZONTAL_ALIGNMENT } from 'constants/ui';
import { alwaysTrue } from 'utils/data';

import { COLUMN_WIDTH, eventDateKey } from './TaskHistoryTable.constants';

export const taskHistoryTableConfig = {
  taskName: {
    label: 'Name',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    width: COLUMN_WIDTH.NAME,
    sort: true,
  },
  status: {
    label: 'State',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    width: COLUMN_WIDTH.STATUS,
    sort: true,
  },
  [eventDateKey]: {
    label: 'Event date',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    width: COLUMN_WIDTH.EVENT_DATE,
    sort: true,
    renderContentAsText: alwaysTrue,
    content: row =>
      row[eventDateKey] ? dayjs(row[eventDateKey]).format(COMMON_DATETIME_FORMAT) : 'N/A',
  },
  userName: {
    label: 'User',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    width: COLUMN_WIDTH.USER,
    sort: true,
  },
  reason: {
    label: 'Event Reason',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    width: COLUMN_WIDTH.EVENT_REASON,
    sort: true,
  },
};
